/**
 * #1106 — multiline fields that store allow-list sanitized HTML.
 */

export const DEFAULT_MULTILINE_RICH_HTML_MAX = 10_000;
export const PROJECT_DESCRIPTION_RICH_HTML_MAX = 100_000;

export const MULTILINE_RICH_HTML_FIELD_LIMITS: Readonly<
  Record<string, number>
> = {
  oppProjectDescription: PROJECT_DESCRIPTION_RICH_HTML_MAX,
  siteAdditionalSiteInformation: DEFAULT_MULTILINE_RICH_HTML_MAX,
  siteAdditionalSizeInformation: DEFAULT_MULTILINE_RICH_HTML_MAX,
  coolingDescription: DEFAULT_MULTILINE_RICH_HTML_MAX,
  coolingDescribeApproach: DEFAULT_MULTILINE_RICH_HTML_MAX,
  coolingDescribeRearDoorLoop: DEFAULT_MULTILINE_RICH_HTML_MAX,
  coolingAdditionalReadinessInfo: DEFAULT_MULTILINE_RICH_HTML_MAX,
  powerFacilityDescription: DEFAULT_MULTILINE_RICH_HTML_MAX,
  powerLargeUpsDescription: DEFAULT_MULTILINE_RICH_HTML_MAX,
  powerFireSuppressionNeeds: DEFAULT_MULTILINE_RICH_HTML_MAX,
  powerAdditionalInformation: DEFAULT_MULTILINE_RICH_HTML_MAX,
  rackDescribeElevations: DEFAULT_MULTILINE_RICH_HTML_MAX,
  rackDescription: DEFAULT_MULTILINE_RICH_HTML_MAX,
  rackAdditionalRackInformation: DEFAULT_MULTILINE_RICH_HTML_MAX,
  smallUpsDescription: DEFAULT_MULTILINE_RICH_HTML_MAX,
  powerSmallUpsDescription: DEFAULT_MULTILINE_RICH_HTML_MAX,
  powerSmallUpsAdditionalInfo: DEFAULT_MULTILINE_RICH_HTML_MAX,
  lcAdditionalInformationSfn: DEFAULT_MULTILINE_RICH_HTML_MAX,
  lcDescription: DEFAULT_MULTILINE_RICH_HTML_MAX,
  mgmtDescribeMonitoringControlSoftwareNeeds: DEFAULT_MULTILINE_RICH_HTML_MAX,
  powerTapOfBoxRequirements: DEFAULT_MULTILINE_RICH_HTML_MAX,
  fb_comments: DEFAULT_MULTILINE_RICH_HTML_MAX,
};

export function isMultilineRichHtmlFieldKey(key: string): boolean {
  return Object.prototype.hasOwnProperty.call(
    MULTILINE_RICH_HTML_FIELD_LIMITS,
    key,
  );
}

export function multilineRichHtmlMaxLength(key: string): number {
  return (
    MULTILINE_RICH_HTML_FIELD_LIMITS[key] ?? DEFAULT_MULTILINE_RICH_HTML_MAX
  );
}
